module.exports = __webpack_public_path__ + "img/shobe2.fd67dbcb.jpg";